package com.parmartechnologies.commerce.feature.inventory.viewModel.discount

import com.parmartechnologies.core.feature.inventory.discount.model.Discount
import com.parmartechnologies.core.feature.inventory.discount.network.CreateDiscountRequest
import com.parmartechnologies.core.feature.inventory.discount.network.RetrieveDiscountRequest
import com.parmartechnologies.core.feature.inventory.discount.network.RetrieveDiscountResponse
import com.parmartechnologies.core.feature.inventory.discount.network.UpdateDiscountRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.inventory.handler.DiscountHandler
import com.parmartechnologies.commerce.feature.inventory.network.discount.DiscountNetwork
import com.parmartechnologies.commerce.feature.inventory.repository.DiscountRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.storage.table.inventory.discount.DiscountDatabaseTable
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class DiscountViewModel(val business: Business, val repository: DiscountRepository = DiscountHandler.shared().repository) :
    AppViewModel() {

    val allDiscount: StateFlow<List<Discount>>
        get() = repository.discountLiveData

    val selectedDiscount: StateFlow<Discount?>
        get() = repository.selectedDiscount

    fun fetchAllDiscount() {
        loadFromStorage()
        val request =
            RetrieveDiscountRequest(business._id)
        // startLoading()
        scope.launch {
            DiscountNetwork().retrieve(request) { it: RetrieveDiscountResponse?->
                stopLoading()
                DiscountDatabaseTable().insert(it?.payload)
                loadFromStorage()
            }
        }
    }

    fun loadAllDiscount() {
        loadFromStorage()
        if (allDiscount.value.isEmpty()) {
            fetchAllDiscount()
        }
    }

    private fun loadFromStorage() {
        DiscountDatabaseTable().retrieveAll { data ->
            scope.launch {
                repository.discountLiveData.emit(data)
            }
        }
    }

    fun createNewDiscount(name: String,amount:String, description: String, completion: () -> Unit) {
        val request = CreateDiscountRequest(
            name,
            amount,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            DiscountNetwork().create(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allDiscount: MutableList<Discount> =
                            repository.allDiscount.value.toMutableList()
                        allDiscount.add(it.payload!!)
                        repository.discountLiveData.emit(allDiscount)
                        DiscountDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }

    fun updateDiscount(name: String, id: String, amount:String, description: String, completion: () -> Unit) {
        val request = UpdateDiscountRequest(
            name,
            id,
            amount,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            DiscountNetwork().update(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allDiscount: MutableList<Discount> =
                            repository.allDiscount.value.toMutableList()
                        allDiscount.add(it.payload!!)
                        repository.discountLiveData.emit(allDiscount)
                        DiscountDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }
}